module.exports = {"532925101":"弥城镇","532925102":"红岩镇","532925103":"新街镇","532925104":"寅街镇","532925105":"苴力镇","532925106":"密祉镇","532925203":"德苴乡","532925204":"牛街彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532925.json
// module id = 2652
// module chunks = 0